import { Injectable } from "@angular/core";
import { IdWording } from "../../models/idWording.model";
import { AppSqlProvider } from "../../persistence/app.sql.provider";
import { LoggerService } from "../../services/logs/logger.service";
import { DbDaoBase } from "./base/db.dao.base";

@Injectable({
    providedIn: "root",
})
export class IdWordingDbDao extends DbDaoBase<IdWording> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public async createIndexes(): Promise<void> {
        // Implémentez les index ici si nécessaire
    }

    public createTable(): Promise<void> {
        const query = `
            CREATE TABLE IF NOT EXISTS ${ IdWording.TABLENAME } (
                id TEXT PRIMARY KEY,
                wording TEXT
            );
        `;
        return this.sqlProvider.query(query, [])
            .then(async () => {
                await this.createIndexes();
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    delete(id: string): Promise<any> {
        const deleteQuery = `DELETE FROM ${ IdWording.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(deleteQuery, [id]);
    }

    deleteAll(): Promise<any> {
        const deleteAllQuery = `DELETE FROM ${ IdWording.TABLENAME };`;
        return this.sqlProvider.query(deleteAllQuery, []);
    }

    public get(id: string, hydrate: boolean = false): Promise<IdWording> {
        const selectQuery = `SELECT * FROM ${ IdWording.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(selectQuery, [id])
            .then(data => {
                if (data.rows.length <= 0) {
                    return null;
                }
                return this.rowToModel(data.rows[0]);
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public getTableName(): string {
        return IdWording.TABLENAME;
    }

    protected rowToModel(row: any): IdWording {
        return IdWording.fromRow(row);
    }

    public save(kyWording: IdWording): Promise<IdWording> {
        const query = `
            INSERT OR REPLACE INTO ${ IdWording.TABLENAME } (id, wording)
            VALUES (?, ?);
        `;
        const params = [kyWording.id, kyWording.wording];
        return this.sqlProvider.query(query, params)
            .then(() => {
                return kyWording;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }
}
